var _path, _path2, _line, _line2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10v2a7 7 0 0 1-14 0v-2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 23
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 23,
    x2: 16,
    y2: 23
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7a5 5 0 0 1 0 10",
    strokeDasharray: "1,3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4a10 10 0 0 1 0 16",
    strokeDasharray: "1,4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoice);
export default __webpack_public_path__ + "static/media/icon-voice.aa6d7c700706198c78f228dd8655a17b.svg";
export { ForwardRef as ReactComponent };